import _pick from "lodash/pick";
import _get from "lodash/get";
import _includes from "lodash/includes";
import camelCaseKeys from './camelCase';
export var API_TIMEOUT = 5000;
export default function ApiError(message, response, content) {
  this.name = 'ApiError';
  this.message = message;
  this.stack = new Error(message).stack;
  this.response = response;
  this.content = content;
}
ApiError.prototype = Object.create(Error.prototype);
ApiError.prototype.constructor = ApiError; // Throw errors depending on problem for logging and debugging purposes
// Maybe for routing purposes in the future? Like routing to an error page
// if we can't communicate with the API at all?
// Made to be run in a promise chain for isomorphic fetch so return argument by default

export var handleApiResponse = function handleApiResponse(response) {
  var contentType = response.headers['content-type'];
  var parseMethod = null;

  if (_includes(contentType, 'json')) {
    parseMethod = 'json';
  }

  if (_includes(contentType, 'text')) {
    parseMethod = 'text';
  } // Always parse the response to text or json, this is not ideal since this
  // action is "destructive". We do this because some endpoints return
  // status 200 with json { status: 'ERROR' }


  return Promise.resolve().then(function () {
    if (response.status === 204) {
      return '';
    }

    switch (parseMethod) {
      case 'text':
        return response.data;

      case 'json':
        return camelCaseKeys(response.data, {
          deep: true
        });

      default:
        return '';
    }
  }).then(function (textOrJson) {
    if (!(response.status >= 200 && response.status <= 299) || // Status is not 200-299
    parseMethod === 'json' && textOrJson.status === 'ERROR' || parseMethod === 'json' && _get(textOrJson, 'apiError.status') === 'TRANS_ERROR') {
      var error = new Error("".concat(response.status, " ").concat(response.statusText, " ").concat(response.url));
      error.content = textOrJson;
      error.response = _pick(response, ['status', 'statusText', 'ok', 'type']);
      throw error;
    }

    return textOrJson;
  });
};
//# sourceMappingURL=api.js.map